import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateMinMonthValidator(minDate: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const esInvalido = control.value < minDate;
    const [year, month] = minDate.split('-');
    return esInvalido
      ? { minMonth: `La fecha no puede ser anterior a 01-${month}-${year}.` }
      : null;
  };
}
